import { NgForOf } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  effect,
  inject,
  input,
  Input,
  InputSignal,
} from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { isEmpty } from 'lodash';
import { PointType } from '../../../../../../../team-apis/otterdam/answers/shape-typings';
import { FeedbackPanelComponent } from '../../../../../../feedback/views/feedback-panel/feedback-panel.component';
import { TaskWorkspaceStore } from '../../../../../../h3ml/state/task-workspace-store';
import { FeedbackListService } from '../../../../../../shared/feedback/feedback-list.service';
import { FeedbackListItemComponent } from '../feedback-list-item/feedback-list-item.component';

export interface FeedbackDisplayItem {
  id: string;
  outputId: number;
  title: string;
  errorType: string;
  iconName: string;
  comment?: string;
  shapeId?: number;
  startFrame: number;
  endFrame?: number;
  coordinates?: PointType;
  updatedAt: string;
  isClosed?: boolean;
}

@Component({
  selector: 'h3-feedback-list',
  templateUrl: './feedback-list.component.html',
  styleUrls: ['./feedback-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FeedbackListItemComponent, NgForOf, FeedbackPanelComponent],
})
export class FeedbackListComponent {
  @Input({ required: true }) title!: string;
  protected selectedFeedbackId = toSignal(
    inject(TaskWorkspaceStore)('feedbackPopover')('selectedId').$,
  );
  protected feedback: InputSignal<FeedbackDisplayItem[]> = input(
    [] as FeedbackDisplayItem[],
  );

  private feedbackListService = inject(FeedbackListService);

  constructor() {
    effect(() => {
      if (isEmpty(this.feedback())) {
        this.closeList();
      }
    });
  }

  closeList() {
    this.feedbackListService.clearSelection();
    this.feedbackListService.closeFeedbackList();
  }
}
